import { Component } from "react";
import { SocialLinks } from "../../../Constants";

export default class SocialBar extends Component {
    render() {
        return (
            <ul className="social-bar-list d-flex align-items-center p-0 m-0" style={{ listStyle: 'none' }}>
                {/* 'me-3' adds a margin-end (right side) space */}
                <li className="me-3">
                    <a href={SocialLinks.LINK_FACEBOOK} target="_blank" rel="noopener noreferrer">
                        <i className="fa fa-facebook socialico"></i>
                    </a>
                </li>

                <li>
                    <a href={SocialLinks.LINK_INSTAGRAM} target="_blank" rel="noopener noreferrer">
                        <i className="fa fa-instagram socialico"></i>
                    </a>
                </li>
            </ul>
        );
    }
}